import { render, staticRenderFns } from "./transaction-erp.vue?vue&type=template&id=8c7552e4&"
import script from "./transaction-erp.vue?vue&type=script&lang=js&"
export * from "./transaction-erp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports